<template>
  <div class="short-search-wrapper historical-searches" role="listbox" id="whatAutoComplete">
    <div v-if="searchListHistoyFiltred.length" class="history-searches">
      <div class="autocomplete-title">Dernières recherches</div>
      <ul class="autocomplete-items" role="listbox" aria-labelledby="history-searches-title">
        <li v-for="searchItem in searchListHistoyFiltred" class="search-item" :ref="setListItems" :key="searchItem"
          role="option" tabindex="-1" @keyup.enter="$emit('onClickSearchText', tryDecode(searchItem))"
          @click.prevent="handleItemClick(searchItem)">
          <i class="icon-history" aria-hidden="true"></i>
          <span>{{ tryDecode(searchItem) }}</span>
          <template v-if="!HistoryHasSearch">
            <button type="button" @click.stop="$emit('onRemoveSearchItem', encodeURIComponent(tryDecode(searchItem)));"
              class="clear-item-search" role="option">
              <i class="icon-close" aria-hidden="true"></i>
              <span class="sr-only">Supprimer</span>
            </button>
          </template>
        </li>
        <li v-if="!HistoryHasSearch" class="autocomplete-clear autocomplete-processed" :ref="setListItems"
          @keyup.enter="clickInner" tabindex="-1">
          <button type="button" data-location="0" @click="$emit('onClearSearchHistory');">
            <i class="icon-close" aria-hidden="true"></i>
            Effacer l'historique de recherche
          </button>
        </li>
      </ul>
    </div>
    <div v-if="searchListApi?.length" class="recent-searches popular-searches">
      <div class="autocomplete-title">
        Recherches suggérées
      </div>
      <ul class="autocomplete-items" role="listbox" aria-labelledby="popular-searches-title">
        <li v-for="searchItem in searchListApi" :ref="setListItems" role="option" :key="searchItem" class="search-item"
          tabindex="-1" @keyup.enter="handleItemClick(searchItem)"
          @click.prevent="handleItemClick(searchItem)">
          <i class="icon-search" aria-hidden="true"></i>
          <span>{{ searchItem }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { onBeforeUpdate, watch, nextTick } from 'vue';

export default {
  props: {
    displayListSearch: { type: Boolean, default: false },
    searchListHistoyFiltred: { type: Array, default: () => [] },
    searchListApi: { type: Array, default: () => [] },
    cursorIndex: { type: Number, default: null },
    searchText: { type: String, default: '' },
    HistoryHasSearch: { type: Boolean, default: false },
  },
  emits: ['onRemoveSearchItem', 'onClearSearchHistory', 'onClickSearchText'],

  setup(props, { emit }) {
    let listItems = [];

    const setListItems = (list) => {
      if (list) {
        listItems.push(list);
      }
    };

    onBeforeUpdate(() => {
      listItems = [];
    });

    watch(() => props.cursorIndex, (newValue, oldValue) => {
      nextTick(() => {
        if (newValue !== oldValue) {
          if (listItems.length && listItems[newValue]) {
            listItems[newValue].focus();
          }
        }
      });
    });

    const tryDecode = (str) => {
      try {
        return decodeURIComponent(str);
      } catch (e) {
        return str;
      }
    };

    const clickInner = ($event) => {
      $event.preventDefault();
      $event.stopPropagation();
      if (!$event.target) return;

      const child = $event.target.querySelector('a, button');
      if (child) {
        child.click();
      }
    };
    const handleItemClick = (item) => {
      emit('onClickSearchText', tryDecode(item));
      emit('closeList');
    };

    return {
      setListItems,
      clickInner,
      tryDecode,
      handleItemClick,
    };
  },
};
</script>
